import * as Types from '../../../../graphql/__generated__/globalTypes';

import { gql } from '@apollo/client';
export type ShopLocationContextFragment = { __typename?: 'ShopLocation', id: string, name: string };

export const ShopLocationContextFragmentDoc = gql`
    fragment ShopLocationContext on ShopLocation {
  id
  name
}
    `;